var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemAddonGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.5H5.5V5.5H3.5V6.5H5.5V8.5H6.5V6.5H8.5V5.5H6.5V3.5ZM6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM6 10C3.795 10 2 8.205 2 6C2 3.795 3.795 2 6 2C8.205 2 10 3.795 10 6C10 8.205 8.205 10 6 10Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 17.4167C10.8333 18.425 11.6583 19.25 12.6667 19.25H27.3333C28.3417 19.25 29.1667 18.425 29.1667 17.4167V14.6667H10.8333V17.4167ZM12.6667 16.5H27.3333V17.4167H12.6667V16.5Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.105 10.5417C24.3175 10.5417 24.1892 11.4583 23.0525 11.4583C21.9617 11.4583 21.7508 10.5417 20 10.5417C18.2125 10.5417 18.0842 11.4583 16.9475 11.4583C15.8567 11.4583 15.6458 10.5417 13.895 10.5417C12.1075 10.5417 11.9792 11.4583 10.8425 11.4583V13.2917C12.5842 13.2917 12.8317 12.375 13.9133 12.375C15.0042 12.375 15.215 13.2917 16.9658 13.2917C18.7533 13.2917 18.8817 12.375 20.0183 12.375C21.1092 12.375 21.32 13.2917 23.0708 13.2917C24.8583 13.2917 24.9867 12.375 26.1233 12.375C27.2142 12.375 27.4067 13.2733 29.1667 13.2917L29.1575 11.4767C27.6817 11.1742 27.6725 10.5417 26.105 10.5417Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 8.25C29.185 4.58333 25.2433 2.75 20 2.75C14.7658 2.75 10.8333 4.58333 10.8333 8.25V9.16667H29.1667V8.25ZM12.8317 7.33333C13.5925 5.32583 16.8925 4.58333 20 4.58333C23.0342 4.58333 25.4358 5.2525 26.5908 6.4075C26.8658 6.69167 27.0675 6.99417 27.1867 7.33333H12.8317Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemAddonGroup);
export default __webpack_public_path__ + "static/media/ItemAddonGroup.08fd5242.svg";
export { ForwardRef as ReactComponent };